import * as React from "react";

export function useInterval(callback: () => void, delay: number | null) {
  // This is a ref because we don't want to re-start the interval. We only want
  // to update the latest callback when the timeout completes.
  const savedCallback = React.useRef<(() => void) | undefined>(undefined);

  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }

    if (delay === null) {
      return;
    }

    const id = window.setInterval(tick, delay);
    return () => window.clearInterval(id);
  }, [delay]);
}
